import React, {useEffect} from "react"
// import { Link } from "gatsby"

import "../styles/sass/clock.scss"

const Clock = ({time}) => {

  let rotations = [0, 0, 0] // [second, minutes, hours]
    
  const setTime = () => {
    // const secondline = document.querySelector('.line-second');
    const minuteline = document.getElementsByClassName('line-minute');
    const hourline = document.getElementsByClassName('line-hour');
    const clocks = document.getElementsByClassName('clocks');
  
    const now = new Date();

    const seconds = now.getSeconds();
    const minutes = now.getMinutes();
    const hours = now.getHours() % 12;

    if (seconds === 0) {
      rotations[0]++;
    }

    if (minutes === 0 && seconds === 0) {
      rotations[1]++;
    }

    if (hours === 0 && minutes === 0 && seconds === 0) {
      rotations[2]++;
    }

    // const secondsDeg = (seconds / 60 * 360) + (rotations[0] * 360);
    const minutesDeg = (minutes / 60 * 360) + (rotations[1] * 360);
    const hoursDeg = (hours / 12 * 360) + (minutes / 60 * 30) + (rotations[2] * 360);

    // secondline.style.transform = `rotate(${secondsDeg}deg)`;
    // minuteline.style.transform = `rotate(${minutesDeg}deg)`;
    // hourline.style.transform = `rotate(${hoursDeg}deg)`;

    // we have 2 clocks - one in the footer and one in the overlay
    for (var i = 0; i < minuteline.length; i++) {
      minuteline[i].style.transform = `rotate(${minutesDeg}deg)`;
    }
    for (var i = 0; i < hourline.length; i++) {
      hourline[i].style.transform = `rotate(${hoursDeg}deg)`;
    }

    // console.log(document.getElementById('clock-container').style.opacity);
    // for (var i = 0; i < clocks.length; i++) {
    //   clocks[i].style.visibility = 'visible';
    // }
  };
    
  // const showClock = () => {
  //   // console.log(document.getElementById('clock-container').style.opacity)
  //   // document.getElementById('clock-container').style.opacity = '1.0'
  //   // console.log(document.getElementById('clock-container').style.opacity)
  //   document.getElementById('clock-container').style.visibility = 'visible'
  // };
  
  useEffect(() => {
    setTime();
    // setTimeout(showClock, 100);
    setInterval(setTime, 1000);
  });

  return (
  <>
    <div id="clock-container" class="clock-container">
      <svg class="clock">
        <circle cx="50" cy="50" r="48" class="outline"></circle>
        <line id="line-hour" class="line line-hour" x1="50" y1="25" x2="50" y2="50"></line>
        <line id="line-minute" class="line line-minute" x1="50" y1="10" x2="50" y2="50"></line>
        <circle cx="50" cy="50" r="2"></circle>
      </svg>
    </div>
    {/* <div class="clock-container">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="46" height="46">
        <circle cx="23" cy="23" r="22" stroke="white" stroke-width="2" fill="none"></circle>
        <rect id="minutes" width="1" height="14" stroke="white" stroke-width="1" fill="none" x="22" y="10" transform="rotate(30 23 23)"></rect>
        <rect id="hours" width="1" height="8" stroke="white" stroke-width="1" fill="none" x="23" y="16" transform="rotate(300 23 23)"></rect>
      </svg>
    </div> */}
  </>
)}

export default Clock